<iframe frameBorder="0" (load)='isLoading = false;' [src]="cryptedUrl | safe"></iframe>
